import { render, staticRenderFns } from "./wordPreview.vue?vue&type=template&id=306231b1&scoped=true&"
import script from "./wordPreview.vue?vue&type=script&lang=js&"
export * from "./wordPreview.vue?vue&type=script&lang=js&"
import style0 from "./wordPreview.vue?vue&type=style&index=0&id=306231b1&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306231b1",
  null
  
)

export default component.exports